import { ITS_DATA_VALID_YEARS } from '../util/ITS';

const WFS = {
  getITSFootprintDownload: async (footprintName, fileName) => {
    let url = `https://sparcal.sdsc.edu/geoserver/wfs?service=WFS&version=2.0.0&request=GetFeature&typeName=${footprintName}&outputFormat=SHAPE-ZIP`;
    await fetch(url)
      .then(async (response) => {
        return await response.blob();
      })
      .then((blob) => {
        var blobURL = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobURL;
        link.download = fileName + '.zip';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
  },
  getITSDownloadClip: async (wfs_feature_id, coordsString) => {
    const yearFilters = ITS_DATA_VALID_YEARS.year_txt
      .map(
        (year) => `
        <ogc:PropertyIsEqualTo>
          <ogc:PropertyName>year_txt</ogc:PropertyName>
          <ogc:Literal>${year}</ogc:Literal>
        </ogc:PropertyIsEqualTo>`
      )
      .join('\n');

    let wfsBody = `<wfs:GetFeature
      service="WFS"
      version="1.1.0"
      xmlns:wfs="http://www.opengis.net/wfs"
      xmlns:ogc="http://www.opengis.net/ogc"
      xmlns:gml="http://www.opengis.net/gml"
      xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
      xmlns:feature="http://www.your-namespace.org"
      xsi:schemaLocation="http://www.opengis.net/wfs
                      http://schemas.opengis.net/wfs/1.1.0/wfs.xsd"
    >
      <wfs:Query typeName="${wfs_feature_id}" srsName="EPSG:3310">
        <ogc:Filter>
        <ogc:And>

          <ogc:Intersects>
            <ogc:PropertyName>geom</ogc:PropertyName>
            <gml:Polygon srsName="EPSG:3310">
              <gml:exterior>
                <gml:LinearRing>
                  <gml:posList srsDimension="2">
                 ${coordsString}
                  </gml:posList>
                </gml:LinearRing>
              </gml:exterior>
            </gml:Polygon>
          </ogc:Intersects>

            <ogc:Or>
            ${yearFilters}
            </ogc:Or>
          </ogc:And>
        </ogc:Filter>
      </wfs:Query>
    </wfs:GetFeature>`;
    const response = await fetch(
      'https://sparcal.sdsc.edu/geoserver/wfs?&outputFormat=application/json',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: wfsBody,
      }
    );
    return response;
  },
  getCustomWFSDownloadClip: async (wfs_feature_id, coordsString) => {
    let wfsBody = `<wfs:GetFeature
      service="WFS"
      version="1.1.0"
      xmlns:wfs="http://www.opengis.net/wfs"
      xmlns:ogc="http://www.opengis.net/ogc"
      xmlns:gml="http://www.opengis.net/gml"
      xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
      xmlns:feature="http://www.your-namespace.org"
      xsi:schemaLocation="http://www.opengis.net/wfs
                      http://schemas.opengis.net/wfs/1.1.0/wfs.xsd"
    >
      <wfs:Query typeName="${wfs_feature_id}" srsName="EPSG:3310">
        <ogc:Filter>
          <ogc:Intersects>
            <ogc:PropertyName>the_geom</ogc:PropertyName>
            <gml:Polygon srsName="EPSG:3310">
              <gml:exterior>
                <gml:LinearRing>
                  <gml:posList srsDimension="2">
                 ${coordsString}
                  </gml:posList>
                </gml:LinearRing>
              </gml:exterior>
            </gml:Polygon>
          </ogc:Intersects>
        </ogc:Filter>
      </wfs:Query>
    </wfs:GetFeature>`;
    const response = await fetch(
      'https://sparcal.sdsc.edu/geoserver/wfs?&outputFormat=application/json',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: wfsBody,
      }
    );
    return response;
  },
};
export default WFS;
